import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt40 from "@/pages/articles/DiagnosedDepressionAt40";
export const Route = createFileRoute("/diagnosed-with-depression-at-40")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 40 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 40 often hits during peak responsibilities. Learn about TMS, SAINT TMS, and treatment options for midlife depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 40 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 40 often hits during peak responsibilities. Learn about TMS, SAINT TMS, and treatment options for midlife depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-40",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-40",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt40 />;
}
